import { useLocation, matchPath } from 'react-router-dom'
import { viewsArray } from '../views'
// export default function useNotFound () {
//   const location = useLocation()
//   const path = location.pathname

//   if (path && path.length > 1 && viewsArray.find((viewItem) => {
//     return matchPath(path, { path: '/' + viewItem.path })
//   })) {
//     return false
//   }
//   return true
// }
export default function useNotFound () {
  const location = useLocation()
  const path = location.pathname

  /* global localStorage */
  const userMenus = JSON.parse(localStorage.getItem('menu'))

  const protectedMenu = userMenus && userMenus.find((menuItem) => { // girilen route icin kullanıcıya tanımlı bir ust menu varsa onu doner.
    return menuItem.route !== null && path === menuItem.route
  })

  const protectedSubMenu = userMenus && userMenus.find((menuItem) => { // girilen route icin kullanıcıya tanımlı bir submenu varsa onu doner.
    return menuItem.route === null && menuItem.items && menuItem.items.find((subMenuItem) => {
      return path === subMenuItem.route
    })
  })

  if (location.pathname.startsWith('/login') || location.pathname.startsWith('/supportRequests')|| location.pathname.startsWith('/processingOfPersonalData')) { // login her kullanıcıya gosterilen bir sayfadır.
    return false
  }
  if (path && path.length > 1 && viewsArray.find((viewItem) => { // girilen route icin tum views'lerin icinde varsa
    return matchPath(path, { path: '/' + viewItem.path })
  })) {
    if (protectedMenu !== undefined || protectedSubMenu !== undefined) { // kullanıcının sayfaya girmeye yetkisi varsa
      return false
    } else {
      return true
    }
  }
  return true
}
